// extracted by mini-css-extract-plugin
module.exports = {"column":"Sidebar_column__3bNqI","menuIcon":"Sidebar_menuIcon__EqPTm","navItem":"Sidebar_navItem__1Z9xn","active":"Sidebar_active__71qiq","draweHeader":"Sidebar_draweHeader__1P0Nq"};